import React, { Component, PropTypes } from 'react';
import SaveSearch from 'SaveSearch/SaveSearchWrapper.js';
import JobMail from 'JobMail/JobMailWrapper';

class SavePanel extends Component {
  static propTypes = {
    authenticated: PropTypes.bool.isRequired
  }

  render() {
    if (this.props.authenticated) {
      return (
        <SaveSearch />
      );
    }

    return (<JobMail />);
  }
}

export default SavePanel;



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanel/SavePanel.js
 **/